import { http } from '@/core/helpers/http.helper';
import { GenerateDescriptionRequest } from './generate-description.interface';
export class GenerateDescriptionService {
   async getGenerateDescriptions() {
      throw Error('Method not implemented');
   }

   async getGenerateDescription() {
      throw Error('Method not implemented');
   }

   async postGenerateDescription(descriptionData: GenerateDescriptionRequest) {
      const response = await http.post(`/positions/generate-description`, descriptionData);
      return response.data;
   }

   async putGenerateDescription() {
      throw Error('Method not implemented');
   }

   async deleteGenerateDescription() {
      throw Error('Method not implemented');
   }
}
